import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const quotes = ['No estás roto. Estás esperando el mapa correcto.', 'El dolor que callas es el que más te controla.', 'Sobrevivir no es lo mismo que vivir. Y tú lo sabes.', 'Lo que te rompió también te reveló quién eres cuando todo falla.', 'No tienes que esperar a no sentir dolor para empezar a sanar.', 'Dios no te define por tus peores momentos. ¿Por qué tú sí?', 'Tu historia no es tu vergüenza. Es tu poder.', 'No vas lento. Estás enraizando.', 'El problema no eres tú. Es que nadie te dio el proceso correcto.', 'Cada día que decides seguir es una victoria sobre la versión de ti que se rindió.'];
export function SoulQuotes() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-269">
      <div className="max-w-4xl mx-auto px-6" data-id="element-270">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="font-display text-4xl md:text-5xl text-[var(--warm-gold)] text-center mb-20" data-id="element-271">
          Verdades Que Necesitabas Escuchar
        </motion.h2>

        <div className="space-y-16" data-id="element-272">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="text-center" data-id="element-273">
              <blockquote className="font-display text-2xl md:text-3xl italic text-[var(--cream)] leading-relaxed" data-id="element-274">
                "{quote}"
              </blockquote>
              <div className="w-16 h-px bg-[var(--warm-gold)]/50 mx-auto mt-8" data-id="element-275" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}